import React from 'react';

const Vue_v_model = () => {
  return (
    <div>
      <h1>Vue_v_model Component</h1>
      <p>This is the Vue_v_model tutorial page.</p>
    </div>
  );
}

export default Vue_v_model;
